import { ComponentPropsWithoutRef } from 'react';
import { Typography } from '../../../ui';

export function Li(props: ComponentPropsWithoutRef<'li'>) {
  const { children, ...rest } = props;

  return (
    <Typography as="li" variant="body-s" color="grayscale500" {...rest}>
      {children}
    </Typography>
  );
}
